module.exports = __webpack_public_path__ + "img/vignettes-asso_0001_revelations-culturelles.1d44d116.jpg";